import { Observable, Subject, share } from 'rxjs';
import { UbieState } from '../interfaces';

export class UbieDeviceCommunicationResult {
  readonly ubieState$: Observable<UbieState>;
  constructor(ubieDeviceComm: Subject<UbieState>) {
    this.ubieState$ = ubieDeviceComm.asObservable().pipe(share());
  }
}
